import type { LocationQuery } from 'vue-router'
import { Calendar, ToggleLeft, GitBranch } from 'lucide-vue-next'
import { buildScopedListQuery } from '@/shared/utils/scopedContext'

export const UC_USER_CALL_FLOW_SETTINGS_ROUTE_NAME = 'uc-user-call-flow-settings' as const
export const UC_USER_CALL_FLOW_SETTINGS_ACCOUNT_ROUTE_NAME =
  'uc-user-call-flow-settings-account' as const
export const UC_USER_TWO_WAY_TOGGLES_LIST_ENDPOINT = '/uc-user/two-way-toggles' as const
export const UC_USER_MULTIWAY_TOGGLES_LIST_ENDPOINT = '/uc-user/multiway-toggles' as const
export const UC_USER_SCHEDULES_LIST_ENDPOINT = '/uc-user/schedules' as const

export const UC_USER_CALL_FLOW_SETTINGS_TEST_IDS = {
  page: 'uc-user-call-flow-settings-page',
  accountPage: 'uc-user-call-flow-settings-account-page',
  schedulesTab: 'uc-user-call-flow-settings-schedules-tab',
  twoWayTab: 'uc-user-call-flow-settings-two-way-tab',
  multiwayTab: 'uc-user-call-flow-settings-multiway-tab',
  listTable: 'uc-user-two-way-toggles-list-table',
  multiwayListTable: 'uc-user-multiway-toggles-list-table',
  readOnlyAlert: 'uc-user-two-way-toggles-readonly-alert'
} as const

export const callFlowSettingsTabs = [
  {
    id: 'schedules',
    label: 'Schedules',
    description: 'Time and date based routing',
    icon: Calendar
  },
  {
    id: 'two-way-toggles',
    label: 'Two-Way Toggles',
    description: 'Night mode red/green routing',
    icon: ToggleLeft
  },
  {
    id: 'multiway-toggles',
    label: 'Multiway Toggles',
    description: 'Unlimited-path toggle routing',
    icon: GitBranch
  }
] as const

export const CALL_FLOW_SETTINGS_TAB_COPY = {
  schedules: 'Time and date based routing for holidays and recurring events, like Open Hours.',
  twoWay: 'Single-state toggle routing with red/green (on/off) paths, sometimes called Night Mode.',
  multiway:
    'Single-state toggle routing with unlimited paths, useful for on-call employees and alternative/holiday IVR handling.'
} as const

export function buildUcUserCallFlowSettingsListQuery(routeQuery?: LocationQuery) {
  return buildScopedListQuery({ accountId: null }, routeQuery)
}

export function buildUcUserCallFlowSettingsListRoute(routeQuery?: LocationQuery) {
  return {
    name: UC_USER_CALL_FLOW_SETTINGS_ROUTE_NAME,
    query: buildUcUserCallFlowSettingsListQuery(routeQuery)
  }
}

export function buildUcUserCallFlowSettingsAccountRoute(
  accountId: string | number,
  routeQuery?: LocationQuery
) {
  return {
    name: UC_USER_CALL_FLOW_SETTINGS_ACCOUNT_ROUTE_NAME,
    query: buildScopedListQuery({ accountId }, routeQuery)
  }
}
